module.exports = __webpack_public_path__ + "img/05.777f2099.jpg";